module.exports = __webpack_public_path__ + "img/donante-anahuac.079390cb.jpeg";